import { Route, Router, Switch } from 'wouter-preact';

import { useMediaQuery, useQueryLocation } from './hooks';
import { AuthProvider } from './context/AuthContext';

import { VideoLibrary, Calendar, BadgesPage } from './pages';

import {
  CalendarLink,
  BadgesLink,
  VideosLink,
  CollectionLink,
  ProfileLink,
  FacebookLink,
} from './components';

function App() {
  const isDesktop = useMediaQuery(1024);

  return (
    <AuthProvider>
      <Router hook={useQueryLocation}>
        <main>
          <Switch>
            <Route path="/" component={VideoLibrary} />
            <Route path="/calendar" component={Calendar} />
            <Route path="/badges" component={BadgesPage} />
          </Switch>
        </main>

        <aside>{isDesktop ? <></> : <MobileNav />}</aside>
      </Router>
    </AuthProvider>
  );
}

const MobileNav = () => {
  const [, navigate] = useQueryLocation();

  return (
    <nav class="tw-fixed tw-bottom-0 tw-bg-black tw-w-full tw-z-50" style="height: 70px; padding-bottom: 20px;">
      <ul class="tw-grid tw-grid-cols-5 tw-h-full [&_li]:tw-flex [&_li]:tw-justify-center [&_li]:tw-items-center tw-p-0 tw-m-0 tw-pt-[10px]">
        <li>
          <button onClick={() => navigate('/calendar')} class="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0 tw-flex tw-items-center tw-justify-center" style="width: 38px; height: 38px;">
            <CalendarLink width="38" height="38" />
          </button>
        </li>
        <li>
          <button onClick={() => navigate('/badges')} class="tw-bg-transparent tw-border-0 tw-cursor-pointer tw-p-0 tw-flex tw-items-center tw-justify-center" style="width: 38px; height: 38px;">
            <BadgesLink width="38" height="38" />
          </button>
        </li>
        <li style="position: relative;">
          <button 
            class="tw-border-0 tw-cursor-pointer tw-p-0 tw-flex tw-items-center tw-justify-center tw-absolute tw-rounded-full" 
            onClick={() => navigate('/')} 
            style="width: 62px; height: 62px; top: -20px; left: 50%; transform: translateX(-50%); background-color: #b6e0f8; border: 5px solid #000;"
          >
            <VideosLink width="64" height="64" />
          </button>
        </li>
        <li>
          <a href="https://www.facebook.com/share/g/1ADj3sTSs8/" target="_blank" rel="noopener noreferrer" class="tw-flex tw-items-center tw-justify-center" style="width: 38px; height: 38px;">
            <FacebookLink width="38" height="38" />
          </a>
        </li>
        <li>
          <a 
            href="/account" 
            onClick={(e) => { 
              e.preventDefault(); 
              sessionStorage.removeItem('was_on_habit_tracker'); 
              window.location.href = '/account'; 
            }}
            class="tw-flex tw-items-center tw-justify-center" 
            style="width: 38px; height: 38px;"
          >
            <ProfileLink width="38" height="38" />
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default App;
